module.exports = __webpack_public_path__ + "static/media/middle@2x.38357982.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Skwiz/middle@2x.png
// module id = ./src/assets/Skwiz/middle@2x.png
// module chunks = 0